export const ParserStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
        minHeight: '500px',
        grid: {
           width: '100%',
          display: 'flex',
          justifyContent: 'center',
          hero: { width:'30%'},
          fieldHeader: { width:'70%',paddingTop:'5rem'},
          fieldContent: { width:'58%'}
        }

    },
  },
};
